import { useEffect, useRef, useState } from 'react';

import {
  Button,
  Flex,
  FormControl,
  FormHelperText,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Textarea
} from '@chakra-ui/react';

import * as yup from 'yup';
import { DealerProfileType } from '@masterffl/dealer-profile-component';
import {
  callToCreateDealerAction,
  setIsCreateDealerActionCompleted,
} from '@/explore/ducks/slice';
import { useDispatch } from 'react-redux';
import {
  getIsCreateDealerActionCompleted,
  getIsCreateDealerActionInprogress
} from '@/explore/ducks/selectors';

type Props = {
  open: boolean;
  close: () => void;
  details?: DealerProfileType;
};

const BioEditModal = ({ open, close, details }: Props) => {
  const dispatch = useDispatch();
  const isCreateDealerActionCompleted = getIsCreateDealerActionCompleted();
  const isCreateDealerActionInprogress = getIsCreateDealerActionInprogress();

  const [description, setDescription] = useState<{ id: string; value: string; error?: string; defaultValue: string }>({
    id: 'description',
    value: '',
    error: '',
    defaultValue: ''
});
  const [textareaEvent, setTextareaEvent] = useState<any>(null);
  const descriptionText = useRef(null) as unknown as React.MutableRefObject<HTMLInputElement>;

const formSchema = yup.object().shape({
    description:yup.string(),
})
async function validation(
  value: string,
  fieldName: string
) {
  try {
      await formSchema.validateAt(fieldName, { [fieldName]: value });
      return '';
  } catch (error: any) {
      console.error("SHEMA ERR : ", error);
      return error.errors && error.errors.length > 0 ? error.errors[0] : '';
  }
}
const onChangeDesciption = async (value: string, fieldName: string) => {
        const error = await validation(value, fieldName);
        const descriptionData = {
            ...description,
            value: value,
            error: ''
          } 
          if (error) {
            descriptionData['error'] = error;
            }
          else if(value === '')  {
            descriptionData['error'] = 'Business Description cannot be empty';
          }
        setDescription(descriptionData);
        
} 
useEffect(() => {
  descriptionText?.current?.setSelectionRange(textareaEvent, textareaEvent);
}, [description.value])

useEffect(()=>{
if(details?.businessDetails?.bio){
    setDescription({
        ...description,
        value:details?.businessDetails?.bio,
        defaultValue: details?.businessDetails?.bio
    })
}
},[details])


  const handleSubmit = async () => {
    const licenseKey = details?.licenses?.find((item:any) => item?.isPrimaryForInbound)?.licenseKey;
    const payload:any = {
      name:'bio',
      type:'update',
      license_key: licenseKey,
      source:'ffl360',
      bio: description?.value,
    };
    
    dispatch(
      callToCreateDealerAction({
        bioUpdatePayload: [payload]
      })
    );
  };


  useEffect(() => {
    if (!isCreateDealerActionInprogress && isCreateDealerActionCompleted) {
      close()
      setDescription({...description,error:''})
      dispatch(setIsCreateDealerActionCompleted(false));
    }
  }, [isCreateDealerActionInprogress, isCreateDealerActionCompleted]);

  const onCancelBtnClick = ((isNew:boolean =false) => {
    if(isNew) {
      setDescription({...description,error:''})
    }
    else{
      setDescription({...description,value:description.defaultValue,error:''})
    }
    if(!isCreateDealerActionInprogress)
      close()
   })
  return (
    <Modal closeOnOverlayClick={false} isOpen={open} onClose={close} isCentered>
      <ModalOverlay />
      <ModalContent
        className={`transfer-create-modal`}
        maxWidth={'700px'}
        maxHeight={'90vh'}
        scrollBehavior={'auto'}
      >
        <ModalHeader className="store-contact-details-edit-header">
          Edit Business Description
          <button className="transfer-create-modal__close-btn" onClick={()=> onCancelBtnClick()}>
            <img src="/images/ui/close.svg" />
          </button>
        </ModalHeader>
        <ModalBody className={'store-contact-details-edit-body'}>
          <Flex
            direction={'column'}
            padding={0}
            gap={3}
            borderBottom={'1px solid #D4D4D4'}
            paddingBottom={'20px'}
          >
             <FormControl className="transfer-form__item" padding={' 2rem 1.5rem'}>
                <Textarea display="flex" flexDirection="column" placeholder="Enter Description" height={'120px'}
                value={description?.value}
                onChange={(event) => {
                  onChangeDesciption(event.target.value.trimStart(),'description')
                  setTextareaEvent(event.target.selectionStart);
                }} 
                ref={descriptionText as any}
                >
                </Textarea>
                   {description.error && <FormHelperText color={'red'} paddingLeft={'0.5rem'}>
                        *{description.error}
                    </FormHelperText>
                    }
            </FormControl>
          </Flex>
        </ModalBody>
        <ModalFooter className={`store-contact-details-edit-footer`}>
          <Button
            colorScheme="blue"
            onClick={()=> onCancelBtnClick()}
            background="#ffffff"
            color="#0C1E46"
            border="1px solid #0C1E46"
            padding="8px 11px"
            fontSize={'16px'}
            marginRight="20px"
            height={'35px'}
            width={'100px'}
            isDisabled={isCreateDealerActionInprogress}
          >
            Cancel
          </Button>
          <Button
            colorScheme="blue"
            background="#0C1E46"
            height={'35px'}
            width={'100px'}
            fontSize={'16px'}
            padding="8px 20px"
            onClick={handleSubmit}
            isDisabled={isCreateDealerActionInprogress || description?.value === details?.businessDetails?.bio || description?.value === '' }
            isLoading={isCreateDealerActionInprogress}
          >
            Save
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default BioEditModal;




